import { useEffect, useMemo, useState } from "react";
import GameShell from "../GameShell";

/**
 * Templo do Silêncio — SON-R inspired.
 * 10 trials. Show 4 emoji items, 3 belong to a category, 1 is the odd one. No text.
 * Tap the odd one out.
 */
export default function SilenceTemple() {
  return (
    <GameShell gameId="silence_temple" title="Templo do Silêncio">
      {({ onFinish }) => <Game onFinish={onFinish} />}
    </GameShell>
  );
}

const CATEGORIES = [
  { items: ["🍎", "🍌", "🍇", "🍓", "🍑", "🍊"], odd: ["🚗", "🐶", "⚽", "📕", "🪑"] },
  { items: ["🐶", "🐱", "🐰", "🐯", "🦊", "🐻"], odd: ["🍕", "🚲", "⭐", "🪑", "📕"] },
  { items: ["🚗", "🚓", "🚕", "🚌", "🚒", "🏍️"], odd: ["🐱", "🍎", "🎩", "⭐", "🪑"] },
  { items: ["🎸", "🥁", "🎺", "🎹", "🎻", "🪕"], odd: ["🐶", "🍕", "🚗", "📕", "🌵"] },
  { items: ["⚽", "🏀", "🏈", "⚾", "🎾", "🏐"], odd: ["🍕", "🐰", "🚗", "🪑", "🎵"] },
  { items: ["🌳", "🌲", "🌴", "🌵", "🌿", "🍀"], odd: ["🍕", "🐶", "🚗", "⭐", "🎸"] },
];

const TRIALS = 10;

function buildTrial() {
  const cat = CATEGORIES[Math.floor(Math.random() * CATEGORIES.length)];
  const shuffled = [...cat.items].sort(() => Math.random() - 0.5).slice(0, 3);
  const odd = cat.odd[Math.floor(Math.random() * cat.odd.length)];
  const opts = [...shuffled, odd].sort(() => Math.random() - 0.5);
  return { options: opts, oddItem: odd };
}

function Game({ onFinish }) {
  const [trialIdx, setTrialIdx] = useState(0);
  const [trial, setTrial] = useState(() => buildTrial());
  const [hits, setHits] = useState(0);
  const [misses, setMisses] = useState(0);
  const [feedback, setFeedback] = useState(null);
  const [reactionTimes, setReactionTimes] = useState([]);
  const [started] = useState(() => performance.now());
  const [trialStart, setTrialStart] = useState(() => performance.now());

  const choose = (item) => {
    if (feedback) return;
    const rt = performance.now() - trialStart;
    const correct = item === trial.oddItem;
    setReactionTimes((r) => [...r, rt]);
    if (correct) setHits((h) => h + 1);
    else setMisses((m) => m + 1);
    setFeedback(correct ? "✅" : "❌");
    setTimeout(() => {
      const next = trialIdx + 1;
      if (next >= TRIALS) {
        const elapsed = performance.now() - started;
        const totalHits = hits + (correct ? 1 : 0);
        const totalMisses = misses + (correct ? 0 : 1);
        const allRts = [...reactionTimes, rt];
        const avg = allRts.reduce((a, b) => a + b, 0) / allRts.length;
        onFinish({
          score: Math.max(0, Math.round(totalHits * 10 - totalMisses * 3)),
          duration_ms: Math.round(elapsed),
          metrics: {
            hits: totalHits,
            misses: totalMisses,
            trials: TRIALS,
            avg_reaction_ms: Math.round(avg),
            accuracy: Number((totalHits / TRIALS).toFixed(3)),
          },
        });
      } else {
        setFeedback(null);
        setTrialIdx(next);
        setTrial(buildTrial());
        setTrialStart(performance.now());
      }
    }, 500);
  };

  return (
    <div className="mt-4 max-w-2xl mx-auto" data-testid="silence-area">
      <div className="text-center text-white drop-shadow mb-4">
        <div className="text-sm">Qual figura é DIFERENTE das outras?</div>
        <div className="text-xs mt-1 opacity-80">Rodada {trialIdx + 1} / {TRIALS}</div>
      </div>
      <div className="kid-card pop-in" key={trialIdx}>
        <div className="grid grid-cols-2 gap-4">
          {trial.options.map((it, i) => (
            <button
              key={i}
              onClick={() => choose(it)}
              className="aspect-square rounded-2xl border-2 border-slate-200 text-7xl flex items-center justify-center hover:scale-105 active:scale-95 transition bg-slate-50"
              data-testid={`silence-opt-${i}`}
            >
              {it}
            </button>
          ))}
        </div>
        {feedback && (
          <div className="text-center text-5xl mt-4 pop-in" data-testid="silence-feedback">
            {feedback}
          </div>
        )}
      </div>
    </div>
  );
}
